export default "__VITE_ASSET__DZW$JoeF__"